export const BUILDING_NUMBER_REGEX = /^[0-9]+[a-zA-Z0-9/,.\- ]*$/
